<template>
    <div class="flex items-center">
        <span class="text-red-500" v-if="isBadContact">
            <font-awesome-icon
                :icon="['far', 'exclamation-triangle']"
                class="text-base mr-2 relative"
            />
        </span>
        <span v-else class="text-green-500">
            <font-awesome-icon
                :icon="['far', 'check-circle']"
                class="text-base mr-2 relative"
            />
        </span>
        <div>
            {{status}}
        </div>
    </div>

</template>


<script>

export default {
    name: 'ContactTableStatus',
    props: ['data'],
    data: () => ({
        showTooltip: false,
    }),
    computed: {
        isBadContact() {
            return (
                this.data.bad_contact ||
                this.data.do_not_contact
            )
        },
        status() {
            if (!this.isBadContact) {
                return "Good Contact";
            }

            if (this.data.bad_contact_reason && 
                (this.data.bad_contact_reason.includes("not a valid phone number") ||
                this.data.bad_contact_reason.includes("not a mobile number"))) {
                return "Invalid number";
            }

            if (this.data.do_not_contact ||
                (this.data.bad_contact_reason && 
                (this.data.bad_contact_reason.includes("unsubscribed") ||
                this.data.bad_contact_reason.includes("blacklist")))
            ) {
                return "Opted Out";
            }

            if (this.data.bad_contact_reason.includes("not been enabled for the region") ) {
                return "Outside area";        
            }

            //if we get this far, there must be some other failure...
            return "Bad Contact";
        },
        recipientName() {
            if(this.data.group_id){
            if(this.data.recipient_name.deleted_at) {
                return this.data.recipient_name + ' (Deleted List)'
            } else if(this.data.recipient_name.deleted_at == null) {
                return this.data.recipient_name
            }
            } else {
            return this.data.recipient_name
            }
        }
    },
}


</script>

<style scoped>
.error {
    @apply text-red-700 px-4 py-3;
}

</style>
